import { styled, Theme } from "@mui/material";
import { SxProps } from "@mui/system/styleFunctionSx";

import basicFitLogoSvg from "assets/basic-fit-logo.svg";

const StyledImg = styled("img")({
    height: 40,
    filter: [
        "invert(100%) sepia(0%) saturate(7500%) hue-rotate(80deg) brightness(110%) contrast(109%)",
    ],
});

export interface BasicFitLogoProps {
    sx?: SxProps<Theme>;
}

export default function BasicFitLogo(props: BasicFitLogoProps) {
    return (
        <StyledImg
            src={basicFitLogoSvg}
            sx={[...(Array.isArray(props.sx) ? props.sx : [props.sx])]}
        />
    );
}
